import {ScanRepository} from '../repositories/ScanRepository';
import {Beneficiary} from '../entities/Beneficiary';

export class ScanQRCodeUseCase {
  constructor(private readonly scanRepository: ScanRepository) {}

  async execute(qrCode: string): Promise<Beneficiary> {
    if (!qrCode || qrCode.trim().length === 0) {
      throw new Error('El código QR no puede estar vacío');
    }

    return await this.scanRepository.scanQRCode(qrCode);
  }
}

